import axios from 'axios'
import qs from 'qs'
import {Cookie} from '@/util'
import {Req_AddWarningLog} from '@/request/account'
import {Message} from 'element-ui'
let reqLogFlag = true
function sendReqLog() {
  if(!reqLogFlag) return
  reqLogFlag = false
  const unusual = []
  const suDel = []
  const reqLog = getReqLog()
  for(let key in reqLog) {
    const currTime = new Date().getTime() / 1000
    const cycle = reqLog[key]
    const startTime = new Date(cycle.startTime).getTime() / 1000
    if(currTime - startTime < 30) {
      break
    } else {
      if(!cycle.callbackTime) {
        unusual.push(cycle)
      }else {
        const callbackTime = new Date(cycle.callbackTime).getTime() / 1000
        if(callbackTime - startTime > 5) {
          unusual.push(cycle)
        }
      }
      suDel.push(key)
    }
  }
  
  if(unusual.length) {
    Req_AddWarningLog(unusual).then(res => {
      reqLogFlag = true
      suDel.forEach(key => delete reqLog[key])
      setReqLog(reqLog)
    }).catch(err => reqLogFlag = true)
  }else {
    suDel.forEach(key => delete reqLog[key])
    setReqLog(reqLog)
    reqLogFlag = true
  }
  
}


function getTime() {
  const dateObj = new Date()
  return `${dateObj.getFullYear()}-${dateObj.getMonth() + 1}-${dateObj.getDate()} ${dateObj.getHours()}:${dateObj.getMinutes()}:${dateObj.getSeconds()}`
}


const getReqLog = (function() {
  let reqLog = localStorage.getItem('reqLog')
  try {
    reqLog = reqLog ? JSON.parse(reqLog) : {}
  } catch(err) {
    reqLog = {}
  }
  return () => {
    return reqLog
  }
})()

let reqLogTimer = null

function setReqLog(log) {
  clearTimeout(reqLogTimer)
  reqLogTimer = setTimeout(() => {
    localStorage.setItem('reqLog',JSON.stringify(log))
  },150)
}

function setRequest(axios,cycleId,mask) {
  const reqLog = getReqLog()
  reqLog[cycleId].startTime = getTime()
  setReqLog(reqLog)
  sendReqLog()
  if(window.$request && mask) window.$request.state = true
  axios.interceptors.request.use(config => {
    reqLog[cycleId].requestLink = config.url 
    config.headers['X-Authorization'] = Cookie.get('token')
    return config
  })
}

function setResponse(axios,cycleId,isReturnData) {
  const loginOrder = window.$loginOrder
  axios.interceptors.response.use(res => {
    if(window.$request) window.$request.state = false
    const reqLog = getReqLog()
    reqLog[cycleId] && (reqLog[cycleId].callbackTime = getTime())
    setReqLog(reqLog)
    if(res.data.code === 200) {
      if(isReturnData) {
        return Promise.resolve(res.data)
      }else{
        return Promise.resolve(res.data.result)
      }
    }else {
      return Promise.reject({code:res.data.code,message: res.data.message,loginOrder})
    }
  })
}




export let Global_Url = ''
if (process.env.NODE_ENV === "development") {
  Global_Url = '/api' 
}else {
  if (location.host.includes('ccqf.vip')) {
    Global_Url = 'https://api.ccqf.vip'
  } else if(location.host.includes('localhost')) {
    Global_Url = 'http://localhost:9899'
  } else if (location.host.includes('inforshare')){
    Global_Url = 'http://api.ccqf.inforshare.com'
  }
}

const msg = '自动化登录策略升级优化中，可先使用 “手动导入”模式。不便之处，请多包涵。'

const reqCut = {
  // '/i/tenant/basic/reptile/task/batch/update/status': msg,
  // '/i/tenant/basic/reptile/task/batch/add': msg
}


export const newAxios = function (config,type,mask,isReturnData = false) {
  if (reqCut[config.url]) {
    return Message.info(reqCut[config.url])
  }
  const headers = {}
  config.method = config.method === 'get' ? 'get' : 'post'
  if(config.newApi){
    config.url = config.url
  }else{
    config.url = Global_Url + config.url
  }
  if(type === 'json') {
    headers['Content-Type'] = 'application/json'
  }else if(type === 'multipart'){
    headers['Content-Type'] = 'multipart/form-data'
  } else {
    config.data ? config.data = qs.stringify(config.data) : ''
  }
  const myAxios = axios.create({
    ...config,
    headers
  })
  const cycleId = `${Math.random()}`
  const reqLog = getReqLog()
  reqLog[cycleId] = {
    userId: $cookie.get('jti'),
    customerId: $cookie.get('customerId')
  }
  setReqLog(reqLog)
  setRequest(myAxios,cycleId,mask === false ? false : true)
  setResponse(myAxios,cycleId,isReturnData)
  return myAxios
}




// WEBPACK FOOTER //
// ./src/request/index.js